import { headerConnect as connect } from 'components/Shared/connect';
import { IMenuItem } from 'models/IMenuItem';
import cn from 'classnames';
import styles from './styles.scss';
import { isMenuOpen, toggleMenu } from 'components/MainMenu/actions';
import { SubCategories } from './subcategories';
import { isAllCategoriesMenuItem } from 'components/MainMenu/selectors';

interface OwnProps extends IMenuItem {
  parents: string[];
}

interface MergedProps extends OwnProps {
  selected: boolean;
  toggleMenu: (e: React.MouseEvent<HTMLLIElement>) => void;
}

const MobileMenuItem = ({ toggleMenu, selected, subCategories, id, url, title }: MergedProps) => {
  const hasChildren = subCategories && subCategories.length > 0;
  const allCategories = isAllCategoriesMenuItem(id);
  const displaySubcategories = hasChildren && selected;
  return (
    <li
      onClick={toggleMenu}
      className={cn({
        [styles.selected]: selected,
        [styles.showSelectedMarker]: displaySubcategories
      })}
    >
      <a href={url}>{title}</a>
      {displaySubcategories && <SubCategories {...{ subCategories, allCategories }} />}
    </li>
  );
};

export default connect<MergedProps, OwnProps>(
  ({ header: { mainMenu } }, props: OwnProps) => ({
    selected: isMenuOpen(mainMenu, props)
  }),
  (dispatch, { parents, id }: MergedProps) => ({
    toggleMenu: (e: React.MouseEvent<HTMLLIElement>) => {
      e.stopPropagation();
      dispatch(toggleMenu({ parents, target: id }));
    }
  })
)(MobileMenuItem);
